<template>
  <div>
    <!-- 查询条件 -->
    <div style="margin: 6px 0 0 5px; position: relative">
      <el-form>
        <el-form-item>
          付款时间：
          <el-radio
            v-model="queryForm.evaluateTime"
            @change="timeChange"
            v-for="item in options.evaluateTimeOpt"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
          <div class="my_select_time">
            <el-date-picker
              @change="startDateChange"
              prefix-icon="no_icon"
              v-model="postForm.startDate"
              type="datetime"
              :picker-options="pickerOptionsStart"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div
              class="time_to_text"
              :class="{
                to_text_disabled:
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
              }"
            >
              至
            </div>
            <el-date-picker
              @change="endDateChange"
              prefix-icon="no_icon"
              v-model="postForm.endDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              :picker-options="pickerOptionsEnd"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <el-button
            style="margin-left: 8px"
            class="b1"
            v-zoom="{ from: '售后中心-金额分析', name: '查询' }"
            @click="query()"
            ><span style="marginleft: 4px">
              <i
                class="el-icon-search"
                style="
                  display: inline-block;
                  width: 14px;
                  height: 12px;
                  margin-right: 4px;
                "
              ></i
              >查询</span
            ></el-button
          >
          <el-button style="margin-left: 20px" class="b2" @click="queryOne()"
            ><span style="marginleft: 4px">重置</span></el-button
          >
        </el-form-item>
        <el-button class="exportData" @click="exportData">导出数据</el-button>
      </el-form>
    </div>
    <!-- 提示文案 -->
    <div
      style="
        margin: 26px 0 0;
        font-size: 14px;
        background-color: #fffaee;
        padding: 10px 0;
      "
    >
      <img
        src="@/assets/images/new_icon_waring_yellow.png"
        style="
          display: inline-block;
          float: left;
          position: absolute;
          width: 14px;
          height: 14px;
          color: #ffffff;
          margin: 0px 4px 0 3px;
        "
      />
      <span style="margin-left: 24px"
        >区间：0-1000元<=客户消费金额<100元，依次类推</span
      >
    </div>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据图表</span>
    </div>
    <div id="order-care" :style="{ width: '100%', height: '400px', marginTop: '20px' }"></div>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据报表</span>
    </div>
    <div style="margin-top: 20px">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
        style="width: 100%"
      >
        <el-table-column prop="range" label="消费金额(元)">
        </el-table-column>
        <el-table-column prop="memberCount" label="会员数">
        </el-table-column>
        <el-table-column prop="buyTotalCount" label="订单数">
        </el-table-column>
        <el-table-column label="成交金额">
          <template slot-scope="scope">
            {{ scope.row.buyTotalMoney.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" label="客单价">
          <template slot-scope="scope">
            {{ scope.row.unitPrice.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column label="会员数占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.memberCountRate"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="订单占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.buyTotalRate"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="成交金额占比">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.buyTotalMoneyRate"></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 生成报表 -->
     <generate :control = 'control' 
               v-if="control"
                @transData="(val) => (control = val)"
                @transData1 = 'getphone1'  
                ></generate>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { totalMoneyBuyerCount, exportData,exportDataOne } from "@/api/analysis/monthly-report";
import generate from '../../components/generate_report.vue'
export default {
  name: "monthly_report",
  data() {
    return {
      control:false,
      tableData: [],
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
    };
  },
  components: {
    generate
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function () {
    this.timeChange("30");
    this.query();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        // this.myCharts.resize();
      });
    });
  },
  methods: {
    startDateChange(time) {
      this.postForm.startDate = time
    },

    endDateChange(time) {
      this.postForm.endDate = time
    },

    // 导出数据
    async exportData() {
      this.control = true
    },
    getphone1(val){
      this.postForm.yearRange = 0
      this.postForm.exportRemark = val;
      let paramStr = "";
      for (var key in this.postForm) {
        let temp = "&" + key + "=" + this.postForm[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportDataOne(paramStr).then((res)=>{
         if(res.code==1){
          this.control = true
         }else{
          this.$message.error(res.message);
         }
      })
    },
    // 清除时间函数
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    //查询
    query() {
      let self = this;
      console.log(this.postForm);
      totalMoneyBuyerCount(this.postForm)
        .then((res) => {
          self.zxData.timeFlag = [];
          self.zxData.buyerCount = [];
          self.zxData.tradeCount = [];
          res.data.forEach((val, index) => {
            self.zxData.timeFlag.push(val.range); //时间段日期
            self.zxData.buyerCount.push(val.memberCount); //会员数
            self.zxData.tradeCount.push(val.buyTotalCount); //订单数
          });
          self.zxData.timeFlag = self.zxData.timeFlag.slice(0, self.zxData.timeFlag.length - 1)
          this.tableData = res.data
          self.drawOrderCareBar();
        })
        .catch(() => {});
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "";
      this.postForm.startDate = "";
      this.postForm.endDate = "";
      this.query();
    },
    //时间限制
    timeChange(type) {
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      let nowTime = new Date()
      if (type == 7) {
        this.postForm.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.postForm.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.postForm.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          barWidth: 20,
        },
        legend: {
          data: ["会员数", "订单数"],
          left: 130,
          top: 1,
          itemWidth: 8,
          itemHeight: 8,
          icon: "circle",
        },
        xAxis: {
          // x轴
          type: "category",
          name: "金额区间",
          data: self.zxData.timeFlag,
        },
        yAxis: {
          // y轴
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "会员数",
            data: self.zxData.buyerCount,
            type: "bar",
            smooth: true,
            color: ["#4CDFC0"],
            stack: "总量",
            barWidth: 20,
          },
          {
            name: "订单数",
            data: self.zxData.tradeCount,
            type: "bar",
            smooth: true,
            stack: "总量",
            color: ["#4878FF"],
            barWidth: 20,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-progress-bar {
  padding-right: 70px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin-right: -76px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7e86ec;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

.exportData {
  position: absolute;
  top: 0;
  right: 0;
}

.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin-top: 26px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}

/deep/ {
  .el-radio__label {
    font-size: 14px;
    padding-left: 8px;
  }
}
.section-right-content-box {
  min-width: 1066px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .b1 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 3px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
  }
}
</style>
